<template>
  <b-card class="h-100" v-if="show">
    <div class="row no-gutters">
      <div class="col d-flex justify-content-end">
        <b-icon-x font-scale="2" variant="primary" @click="hideCard" class="close" />
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-md-3 d-flex align-items-center justify-content-center">
        <b-img :src="illustration" fluid></b-img>
      </div>
      <div class="col-md-9 d-flex flex-column justify-content-between">
        <b-card-body>
          <div>
            <h5 class="text-primary">{{ title }}</h5>
            {{ description }}
          </div>
          <div class="d-flex justify-content-end mt-2">
            <b-button
              @click="onClicked"
              :to="route"
              class="font-weight-bold"
              variant="outline-primary"
            >
              {{ buttonText }}
            </b-button>
          </div>
        </b-card-body>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    illustration: String,
    buttonText: String,
    route: String,
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    onClicked() {
      if (!this.route) {
        this.$emit("ctaClicked");
      }
    },
    hideCard: function () {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  background: $color-light;
}

.close {
  cursor: pointer;
}

.disabled {
  opacity: 0.9;
}

.card-progress {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
</style>
